import * as React from 'react'
import NextNProgress from 'nextjs-progressbar'
import { useTheme } from '@mui/material'

export default function PageProgress() {
    const theme = useTheme()
    return <NextNProgress color={theme.palette.primary.main} />
}
